module.exports = __webpack_public_path__ + "img/1737006755908.bc2c49ba.png";